







































































































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import { required } from "vuelidate/lib/validators";
import { Validate } from "vuelidate-property-decorators";
import ConnectToRoomCall from "@/resources/mixins/chime/connectToRoomCall";
import { i18n } from "@/resources/locales";
@Component({
  name: "auto-video-component",
})
export default class AutoVideoComponent extends mixins(
  UserValidator,
  ConnectToRoomCall
) {
  div;
  isDragging = false;
  offsetX;
  offsetY;
  clickCount = 0;
  clickTimeout;
  isAutoRecording = false;
  halfWidth;
  halfHeight;
  hours = 0;
  minutes = 0;
  seconds = 0;
  interval = null;
  chronometer = "00:00:00";
  loading = false;
  activeValidate = true;
  @Validate({ required })
  title = "";
  @Validate({ required })
  description = "";
  autoVideoId = 0;
  mounted() {}
  destroyed(): void {
    this.closeRecording();
  }
  get active() {
    let active = this.$store.getters["SystemStore/getAutoVideo"];
    if (active)
      setTimeout(() => {
        this.load();
      }, 100);
    else {
      this.clearSave();
      this.isAutoRecording = false;
      this.closeRecording();
    }
    return active;
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setAutoVideoAction", e);
  }
  get roomId() {
    return this.$store.getters["MeetingStore/getRoomAutoVideoId"];
  }
  clearSave() {
    this.title = "";
    this.description = "";
    this.closeTooltip();
    this.activeValidate = false;
  }
  load() {
    this.div = document.getElementById("content");
    this.halfWidth = this.div.getBoundingClientRect().width / 2;
    this.halfHeight = this.div.getBoundingClientRect().height / 2;
    this.div.addEventListener("mousedown", this.startDrag);
    document.addEventListener("mousemove", this.moveDiv);
    document.addEventListener("mouseup", this.stopDrag);
    this.div.addEventListener("dblclick", this.resetPosition);
  }
  startDrag(e) {
    this.isDragging = true;
    this.offsetX =
      e.clientX - this.div.getBoundingClientRect().left - this.halfWidth;
    this.offsetY =
      e.clientY - this.div.getBoundingClientRect().top - this.halfHeight;
  }
  moveDiv(e) {
    if (this.isDragging) {
      var posX = e.clientX - this.offsetX;
      var posY = e.clientY - this.offsetY;
      this.div.style.left = posX + "px";
      this.div.style.top = posY + "px";
    }
  }
  stopDrag() {
    this.isDragging = false;
  }
  resetPosition() {
    this.div.style.transition = "left 0.5s, top 0.5s";
    this.div.style.left = "50%";
    this.div.style.top = "7%";
    setTimeout(() => {
      this.div.style.transition = "";
    }, 200);
  }
  autoRecording() {
    if (this.loading) return;
    this.isAutoRecording = !this.isAutoRecording;
    this.clearSave();
    this.loading = true;
    if (this.isAutoRecording) {
      this.$store.dispatch("MeetingStore/startAutoVideoAction", {
        roomId: this.roomId,
        callback: (response) => {
          this.loading = false;
          this.autoVideoId = response.data.id;
          this.connectToRoomAutoVideo(this.$store, this.roomId, response);
          if (!this.interval)
            this.interval = setInterval(this.updateTime, 1000);
        },
        callbackError: (error) => {
          this.loading = false;
          console.log("TTT autoRecording startAutoVideoAction KO ", error);
          this.onError("", error.response.data.detail);
        },
      });
    } else {
      this.$store.dispatch("MeetingStore/stopAutoVideoAction", {
        autoVideoId: this.autoVideoId,
        callback: (response) => {
          this.$store?.dispatch("SidebarStore/setOpenCall", false);
          this.$store?.dispatch("MeetingStore/setMeetingTypeAction", "");
          this.closeRecording();
          this.activeValidate = true;
        },
        callbackError: (error) => {
          console.log("TTT autoRecording stopAutoVideoAction KO ", error);
          this.$store?.dispatch("SidebarStore/setOpenCall", false);
          this.$store?.dispatch("MeetingStore/setMeetingTypeAction", "");
          this.closeRecording();
          this.onError("", error.response.data.detail);
        },
      });
    }
  }
  updateTime() {
    this.seconds++;
    if (this.seconds === 60) {
      this.seconds = 0;
      this.minutes++;
      if (this.minutes === 60) {
        this.minutes = 0;
        this.hours++;
      }
    }
    let h = this.hours < 10 ? "0" + this.hours : this.hours;
    let m = this.minutes < 10 ? "0" + this.minutes : this.minutes;
    let s = this.seconds < 10 ? "0" + this.seconds : this.seconds;
    this.chronometer = h + ":" + m + ":" + s;
  }
  closeRecording() {
    clearInterval(this.interval);
    this.chronometer = "00:00:00";
    this.seconds = 0;
    this.minutes = 0;
    this.hours = 0;
    this.interval = null;
    this.loading = false;
  }
  closeSave() {
    this.activeValidate = false;
    this.closeTooltip();
  }
  saveAutoVideo() {
    if (this.$v.$invalid) {
      this.$v.title.$touch();
      this.$v.description.$touch();
      return;
    }
    let data = {
      videoTitle: this.title,
      videoDescription: this.description,
    };
    this.$store.dispatch("MeetingStore/validateAutoVideoAction", {
      autoVideoId: this.autoVideoId,
      data: data,
      callback: (response) => {
        this.title = "";
        this.description = "";
        this.activeValidate = false;
        this.closeTooltip();
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.saveAutoVideo")
        );
      },
      callbackError: (error) => {
        console.log("TTT saveAutoVideo validateAutoVideoAction KO ", error);
        this.onError("", error.response.data.detail);
      },
    });
  }
  closeTooltip() {
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
  }
}
